/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { CompleteRequestBuilderRequestsMetadata, type CompleteRequestBuilder } from './complete/index.js';
// @ts-ignore
import { FailRequestBuilderRequestsMetadata, type FailRequestBuilder } from './fail/index.js';
// @ts-ignore
import { RefundRequestBuilderRequestsMetadata, type RefundRequestBuilder } from './refund/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/invoices/{invoiceId}/payments/{paymentId}
 */
export interface WithPaymentItemRequestBuilder extends BaseRequestBuilder<WithPaymentItemRequestBuilder> {
    /**
     * The complete property
     */
    get complete(): CompleteRequestBuilder;
    /**
     * The fail property
     */
    get fail(): FailRequestBuilder;
    /**
     * The refund property
     */
    get refund(): RefundRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const WithPaymentItemRequestBuilderUriTemplate = "{+baseurl}/api/invoices/{invoiceId}/payments/{paymentId}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithPaymentItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithPaymentItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    complete: {
        requestsMetadata: CompleteRequestBuilderRequestsMetadata,
    },
    fail: {
        requestsMetadata: FailRequestBuilderRequestsMetadata,
    },
    refund: {
        requestsMetadata: RefundRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
